import React, { useMemo } from 'react';
import { Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import AppLoading from '@Common/appAsyncLoading';

import enhanceRouter from '@App/hoc/enhanceRouter';
import protectedRouters from '@App/hoc/protectedRouters';

const asyncComponent = Component => {
  return Loadable({
    loader: Component,
    loading: AppLoading,
    delay: 200,
    timeout: 10000
  });
};

const lazyRouteProtectedName = ({ component: Component, ...rest }) => {
  const ProtectedComponent = useMemo(
    () => enhanceRouter({ ...rest })(protectedRouters(asyncComponent(Component))),
    [rest.path, rest.name]
  );
  return <Route {...rest} component={ProtectedComponent} />
};

lazyRouteProtectedName.defaultProps = {
  name: '',
  nameDrawer: '',
  propsRoot: {}
};

export default lazyRouteProtectedName;